module.exports = __webpack_public_path__ + "img/email-confirm.453d2121.svg";